export const listItem = (props) => {

    const selectedState = (props.selectedConversation && props.selectedConversation.conversationId === props.conversation.conversationId) ? {
        backgroundColor: `${props.theme.backgroundColor.primary}`
    } : {};

    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "left",
        alignItems: "center",
        cursor: "pointer",
        width: "100%",
        padding: "8px 16px",
        position: "relative",
        ...selectedState,
        '&:hover': {
            backgroundColor: `${props.theme.backgroundColor.primary}`
        },
    }
}

export const itemThumbnailStyle = () => {

    return {
        display: "inline-block",
        width: "60px",
        height: "60px",
        flexShrink: "0",
        '&.custom-status .presence' : {
          width: '15px',
          height: '15px',
          top: '-20px'
        }
    }
}

export const itemDetailStyle = () => {

    return {
        width: "calc(100% - 45px)",
        flexGrow: "1",
        paddingLeft: "16px",
        lineHeight: '1',
        "&[dir=rtl]": {
            paddingRight: "16px",
            paddingLeft: "0",
        }
    }
}

export const itemRowStyle = () => {

    return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
    }
}

export const itemNameStyle = (props) => {

    return {
        fontSize: " 0.9375rem",
        fontWeight: "600",
        display: "block",
        width: "calc(100% - 70px)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        lineHeight: "1",
        marginBottom: '0.5rem',
        color: '#000',
    }
}

export const itemLastMsgStyle = (props) => {

    return {
        margin: "0",
        fontSize: "0.8125rem",
        fontWeight: "400",
        width: "calc(100% - 50px)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        lineHeight: "1",
        color: `#000`,
        marginBottom: '0.5rem'
    }
}

export const itemLastMsgTimeStyle = (props) => {

    return {
        fontSize: "0.75rem",
        width: "70px",
        color: `#000`,
        display: 'block',
        fontWeight: 400,
        lineHeight: '1',
    }
}
